import React from "react";
import Logs from "../../../../components/Logs";
import { VALAQUENTA_API_URL } from "../../../../api";

const ActivitiesEngineLogsTab = (WrappedComponent) => {
  const Comp = (props) => {
    const actionsMapping = {
      add: {
        label: "Add",
        url: `${VALAQUENTA_API_URL}/activitiesengine/api-config/musement/`,
        method: "POST",
      },
      edit: {
        label: "Edit",
        url: `${VALAQUENTA_API_URL}/activitiesengine/api-config/musement/`,
        method: "PATCH",
      },
      delete: {
        label: "Delete",
        url: `${VALAQUENTA_API_URL}/activitiesengine/api-config/musement/`,
        method: "DELETE",
      },
      clone: {
        label: "Clone",
        url: `${VALAQUENTA_API_URL}//activitiesengine/api-config/musement/clone/`,
        method: "POST",
      },
    };

    return <WrappedComponent {...props} actionsMapping={actionsMapping} />;
  };
  return Comp;
};

export default ActivitiesEngineLogsTab(Logs);
